export default "/profile/images/telegram_btn.svg?f79980cec32555472618fa3ad792cd3d";